import { render } from "./ViewUser.vue?vue&type=template&id=35d70b5e"
import script from "./ViewUser.vue?vue&type=script&lang=js"
export * from "./ViewUser.vue?vue&type=script&lang=js"

import "./ViewUser.vue?vue&type=style&index=0&id=35d70b5e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__